import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import PaymentCallback from "@/pages/PaymentCallback";
import Dashboard from "@/pages/Dashboard";
import Gallery from "@/pages/Gallery";
import ArtworkDetail from "@/pages/ArtworkDetail";
import Holdings from "@/pages/Holdings";
import DailyReview from "@/pages/DailyReview";
import Wallets from "@/pages/Wallets";
import Transactions from "@/pages/Transactions";
import Auctions from "@/pages/Auctions";
import AuctionDetail from "@/pages/AuctionDetail";
import Referrals from "@/pages/Referrals";
import Leaderboard from "@/pages/Leaderboard";
import ChangePassword from "@/pages/ChangePassword";
import Admin from "@/pages/Admin";
import MemberGate from "@/components/MemberGate";

const withLayout = (el) => (
  <ProtectedRoute allowTrial>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);

const memberLayout = (el) => (
  <ProtectedRoute allowTrial>
    <Layout><MemberGate>{el}</MemberGate></Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/payment/callback" element={<PaymentCallback />} />

            <Route path="/dashboard" element={withLayout(<Dashboard />)} />
            <Route path="/gallery" element={withLayout(<Gallery />)} />
            <Route path="/gallery/:id" element={withLayout(<ArtworkDetail />)} />
            <Route path="/holdings" element={memberLayout(<Holdings />)} />
            <Route path="/review" element={withLayout(<DailyReview />)} />
            <Route path="/wallets" element={withLayout(<Wallets />)} />
            <Route path="/transactions" element={withLayout(<Transactions />)} />
            <Route path="/auctions" element={memberLayout(<Auctions />)} />
            <Route path="/auctions/:id" element={memberLayout(<AuctionDetail />)} />
            <Route path="/referrals" element={memberLayout(<Referrals />)} />
            <Route path="/leaderboard" element={withLayout(<Leaderboard />)} />
            <Route path="/security" element={withLayout(<ChangePassword />)} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute adminOnly requireActive={false}>
                  <Layout><Admin /></Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-center" richColors duration={5000} closeButton style={{ zIndex: 999999 }} />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
